import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';

export interface IGetAllSAMLConfigurationsRequest {
  results: ISiteSAMLConfiguration[];
  }

export class GetAllSAMLConfigurationsRequest extends Request<{}, IGetAllSAMLConfigurationsRequest> {
  constructor() {
    super('getAllSAMLConfigurations', null);
  }
}
